<template>
  <AppSection id="invoices" type="page" :title="$t($getConst.pages.invoice.edit_invoice)">
    <InvoiceForm :invoice-to-edit-id="invoice_id"></InvoiceForm>
  </AppSection>
</template>

<script>
  import InvoiceForm from "../InvoiceForm";
  import AppSection from "../../../components/common/sections/AppSection";

  export default {
    name: "index",
    components: {AppSection, InvoiceForm},
    data() {
      return {
        invoice_id: this.$route.params.id,
        invoice: null,
        is_loading: false
      }
    }
  }
</script>

<style scoped>

</style>
